<template>
    <div>
        <!-- ALERT BOOTSTRAPOWY NA GÓRZE -->
        <div v-if="statusMessage" :class="['alert alert-dismissible fade show py-2 mb-4', isError ? 'alert-danger' : 'alert-success']" role="alert">
            <span class="small fw-bold">{{ statusMessage }}</span>
            <button type="button" class="btn-close py-2.5" @click="statusMessage = null"></button>
        </div>

        <!-- RZĄD 1: GODZINY + WORKI Z BILETAMI -->
        <div class="row g-4 mb-4">
            
 <!-- SEKCJA 1: TURY GODZINOWE Z LIMITAMI (Z EDYCJĄ INLINE) -->
            <div class="col-md-6">
                <div class="card shadow-sm border-0">
                    <div class="card-header bg-dark text-white py-2">
                        <h5 class="mb-0 fs-6 fw-bold">⏱️ Tury i pojemność kręgielni</h5>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="addSlot" class="mb-3">
                            <div class="row g-2">
                                <div class="col-6">
                                    <input type="text" v-model="newSlotTime" class="form-control form-control-sm" placeholder="Godzina (np. 17:00)" required maxlength="5">
                                </div>
                                <div class="col-4">
                                    <input type="number" v-model.number="newSlotCapacity" class="form-control form-control-sm" placeholder="Max osób" min="1" required>
                                </div>
                                <div class="col-2">
                                    <button type="submit" class="btn btn-sm btn-success w-100 fw-bold">Dodaj</button>
                                </div>
                            </div>
                        </form>

                        <ul class="list-group list-group-flush border-top">
                            <li v-if="slots.length === 0" class="list-group-item text-center text-muted small py-3">Brak dodanych godzin.</li>
                            <li v-for="slot in slots" :key="slot.id" class="list-group-item d-flex justify-content-between align-items-center px-0 py-2 small">
                                <div class="w-100 me-2">
                                    <!-- TRYB PODGLĄDU TEKSTU GODZINY -->
                                    <span v-if="editingSlotTimeId !== slot.id" class="fw-bold fs-6 me-2" :style="{ textDecoration: slot.is_active ? 'none' : 'line-through' }">
                                        {{ slot.time_string }}
                                        <button @click="startEditSlotTime(slot)" class="btn btn-sm btn-link p-0 ms-1 text-decoration-none" style="font-size:0.7rem;">✏️</button>
                                    </span>

                                    <!-- TRYB EDYCJI TEKSTU GODZINY INLINE -->
                                    <div v-else class="input-group input-group-sm d-inline-flex me-2" style="max-width:130px; vertical-align: middle;">
                                        <input type="text" v-model="editSlotTimeValue" class="form-control form-control-sm" maxlength="5">
                                        <button @click="saveSlotTime(slot.id)" class="btn btn-success py-0 px-2" style="font-size:0.75rem;">OK</button>
                                        <button @click="editingSlotTimeId = null" class="btn btn-secondary py-0 px-2" style="font-size:0.75rem;">X</button>
                                    </div>
                                    
                                    <!-- Podgląd limitu osób (stary kod, zostaje bez zmian) -->
                                    <div v-if="editingSlotId !== slot.id" class="d-inline-block">
                                        <span class="badge bg-info text-dark me-2">Limit: {{ slot.total_capacity }} osób</span>
                                        <button @click="startEditSlot(slot)" class="btn btn-sm btn-link p-0 text-decoration-none" style="font-size:0.75rem;">✏️ Zmień</button>
                                    </div>

                                    <div v-else class="input-group input-group-sm d-inline-flex mt-1" style="max-width:180px; vertical-align: middle;">
                                        <input type="number" v-model.number="editSlotValue" class="form-control form-control-sm" min="1">
                                        <button @click="saveSlotCapacity(slot.id)" class="btn btn-success py-0 px-2" style="font-size:0.75rem;">OK</button>
                                        <button @click="editingSlotId = null" class="btn btn-secondary py-0 px-2" style="font-size:0.75rem;">X</button>
                                    </div>

                                    <span :class="['badge ms-2', slot.is_active ? 'bg-success' : 'bg-secondary']" style="font-size:0.65rem;">
                                        {{ slot.is_active ? 'Aktywna' : 'Ukryta' }}
                                    </span>
                                </div>
                                <div class="flex-shrink-0" v-if="editingSlotId !== slot.id && editingSlotTimeId !== slot.id">
                                    <button @click="toggleSlot(slot.id)" class="btn btn-sm btn-outline-warning py-0 px-1 me-1" style="font-size:0.7rem;">Ukryj</button>
                                    <button @click="deleteSlot(slot.id)" class="btn btn-sm btn-outline-danger py-0 px-1" style="font-size:0.7rem;">Usuń</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- SEKCJA 2: WORKI Z BILETAMI -->
            <div class="col-md-6">
                <div class="card shadow-sm border-0">
                    <div class="card-header bg-dark text-white py-2">
                        <h5 class="mb-0 fs-6 fw-bold">🎁 Worki z darmowymi biletami</h5>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="addFreePool" class="mb-3">
                            <div class="row g-2">
                                <div class="col-6">
                                    <input type="text" v-model="newPoolName" class="form-control form-control-sm" placeholder="Nazwa puli" required>
                                </div>
                                <div class="col-4">
                                    <input type="number" v-model.number="newPoolTotal" class="form-control form-control-sm" placeholder="Bilety" min="0" required>
                                </div>
                                <div class="col-2">
                                    <button type="submit" class="btn btn-sm btn-success w-100 fw-bold">Dodaj</button>
                                </div>
                            </div>
                        </form>

                        <ul class="list-group list-group-flush">
                            <li v-for="pool in freePools" :key="pool.id" class="list-group-item d-flex justify-content-between align-items-center px-0 py-2 small">
                                <div class="w-100 me-2">
                                    <div class="fw-bold">{{ pool.name }}</div>
                                    <div v-if="editingPoolId !== pool.id" class="text-muted text-xs">
                                        Zostało: <strong class="text-success">{{ pool.remaining_slots }}</strong> z {{ pool.total_slots }}
                                        <button @click="startEditPool(pool)" class="btn btn-sm btn-link p-0 ms-2 text-decoration-none" style="font-size:0.75rem;">✏️ Edytuj</button>
                                    </div>
                                    <div v-else class="input-group input-group-sm mt-1" style="max-width:200px;">
                                        <input type="number" v-model.number="editPoolValue" class="form-control form-control-sm" min="0">
                                        <button @click="savePoolLimit(pool.id)" class="btn btn-success py-0 px-2">OK</button>
                                        <button @click="editingPoolId = null" class="btn btn-secondary py-0 px-2">X</button>
                                    </div>
                                </div>
                                <button v-if="editingPoolId !== pool.id" @click="deleteFreePool(pool.id)" class="btn btn-sm btn-outline-danger py-0 px-1" style="font-size:0.7rem;">Usuń</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- RZĄD 2: KATEGORIE + PAROWANIE Z GODZINAMI (PEŁNA SZEROKOŚĆ) -->
        <div class="row g-4">
            
            <!-- SEKCJA 3: KATEGORIE (TYLKO NAZWY) -->
            <div class="col-md-4">
                <div class="card shadow-sm border-0">
                    <div class="card-header bg-secondary text-white py-2">
                        <h5 class="mb-0 fs-6 fw-bold">🏆 Kategorie Turniejowe</h5>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="addCategory" class="input-group input-group-sm mb-3">
                            <input type="text" v-model="newCatName" class="form-control" placeholder="Nazwa (np. Mężczyźni Open)" required>
                            <button type="submit" class="btn btn-success fw-bold">Dodaj</button>
                        </form>

                        <ul class="list-group list-group-flush border-top">
                            <li v-for="cat in categories" :key="cat.id" class="list-group-item d-flex justify-content-between align-items-center px-0 py-2 small">
                                <span class="fw-bold text-dark">{{ cat.name }}</span>
                                <button @click="deleteCategory(cat.id)" class="btn btn-sm btn-outline-danger py-0 px-1" style="font-size:0.7rem;">Usuń</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- SEKCJA 4: KREATOR PRZYPISYWANIA DARMOWYCH PUL -->
            <div class="col-md-8">
                <div class="card shadow-sm border-0">
                    <div class="card-header bg-primary text-white py-2">
                        <h5 class="mb-0 fs-6 fw-bold">🔗 Przypisz darmowe bilety do godziny i kategorii</h5>
                    </div>
                    <div class="card-body">
                        
                        <!-- Bezpieczny formularz parowania oparty o pętle Vue -->
                        <form @submit.prevent="assignPoolToCategoryAndSlot" class="row g-2 mb-4 bg-light p-2 rounded border">
                            <div class="col-md-4">
                                <select v-model="assignCatId" class="form-select form-select-sm" required>
                                    <option value="">-- Wybierz kategorię --</option>
                                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <select v-model="assignSlotId" class="form-select form-select-sm" required>
                                    <option value="">-- Godzina --</option>
                                    <option v-for="slot in slots" :key="slot.id" :value="slot.id">{{ slot.time_string }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <select v-model="assignPoolId" class="form-select form-select-sm" required>
                                    <option value="">-- Worek darmowy --</option>
                                    <option v-for="pool in freePools" :key="pool.id" :value="pool.id">
                                        {{ pool.name }} (Wolnych: {{ pool.remaining_slots }})
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <button type="submit" class="btn btn-sm btn-primary w-100 fw-bold">Połącz</button>
                            </div>
                        </form>

                        <table class="table table-sm table-hover align-middle mb-0" style="font-size:0.8rem;">
                            <thead class="table-light">
                                <tr>
                                    <th>Kategoria</th>
                                    <th>Godzina tury</th>
                                    <th>Podpięty worek darmowy</th>
                                    <th class="text-end">Akcja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="categorySlotPools.length === 0">
                                    <td colspan="4" class="text-center py-3 text-muted">Brak przypisanych darmowych limitów. Wszystkie tury są domyślnie w pełni płatne.</td>
                                </tr>
                                <tr v-for="item in categorySlotPools" :key="item.id">
                                    <td class="fw-bold">{{ item.category ? item.category.name : 'Brak' }}</td>
                                    <td><span class="badge bg-secondary">⏱️ {{ item.slot ? item.slot.time_string : 'Brak' }}</span></td>
                                    <td>
                                        <span class="text-success fw-bold">🎁 {{ item.free_pool ? item.free_pool.name : 'Brak' }}</span>
                                        <small class="text-muted d-block">(Wolnych: {{ item.free_pool ? item.free_pool.remaining_slots : 0 }})</small>
                                    </td>
                                    <td class="text-end">
                                        <button @click="deleteAssignment(item.id)" class="btn btn-sm btn-outline-danger py-0 px-2" style="font-size:0.7rem;">
                                            Usuń link
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            slots: [],
            freePools: [],
            categories: [],
            categorySlotPools: [], 
            // Mapa relacji z bazy
            newSlotTime: '',
            newSlotCapacity: 20, 
            // Domyślny limit osób na turę
            newPoolName: '',
            newPoolTotal: 0,
            newCatName: '',
            assignCatId: '',
            assignSlotId: '',
            assignPoolId: '',
            statusMessage: null,
            isError: false,
            editingPoolId: null,
            editPoolValue: 0,
            editingSlotId: null,
            editSlotValue: 0,
            editingSlotTimeId: null,
            editSlotTimeValue: '',                        
        };
    },
    mounted() {
        this.loadSlots();
        this.loadFreePools();
        this.loadCategories();
        this.loadCategorySlotPools();
    },
    methods: {
        showAlert(message, errorStatus = false) {
            this.statusMessage = message;
            this.isError = errorStatus;
            setTimeout(() => { 
                this.statusMessage = null; }, 
                4000 );
        },
        // --- GODZINY ---
        loadSlots() { 
            axios.get('/api/admin/slots')
                .then(res => this.slots = res.data); 
        },
        addSlot() {
            axios.post('/api/admin/slots', { 
                time_string: this.newSlotTime, 
                total_capacity: this.newSlotCapacity 
                })
                .then(res => { 
                    this.slots.push(res.data); 
                    this.newSlotTime = ''; 
                    this.showAlert("Dodano godzinę wraz z limitem torów."); 
                })
                .catch(err => this.showAlert(err.response.data.message || "Błąd zapisu.", true)
            );
        }
        ,toggleSlot(id) { 
            axios.post('/api/admin/slots/' + id + '/toggle')
                .then(() => this.loadSlots()); 
        },
        deleteSlot(id) {
            axios.delete('/api/admin/slots/' + id)
                .then(res => { this.showAlert(res.data.message); this.loadSlots(); })
                .catch(err => this.showAlert(err.response.data.message, true));
        },
        // --- WORKI Z BILETAMI ---
        loadFreePools() { 
            axios.get('/api/admin/free-pools')
                .then(res => this.freePools = res.data); 
        },
        addFreePool() {
            axios.post('/api/admin/free-pools', { name: this.newPoolName, total_slots: this.newPoolTotal })
                .then(res => { 
                    this.freePools.push(res.data); 
                    this.newPoolName = ''; 
                    this.newPoolTotal = 0; 
                    this.showAlert("Utworzono worek darmowy."); 
                })
                .catch(err => this.showAlert("Błąd zapisu.", true)
            );
        },
        startEditPool(pool) { 
            this.editingPoolId = pool.id;
            this.editPoolValue = pool.total_slots;
        }
        ,savePoolLimit(id) {
            axios.put('/api/admin/free-pools/' + id, { total_slots: this.editPoolValue })
                .then(() => { 
                    this.editingPoolId = null;
                    this.loadFreePools();
                    this.loadCategorySlotPools();
                    this.showAlert("Zmieniono limit worka."); 
                }).catch(err => this.showAlert(err.response.data.message, true)
            );
        },
        deleteFreePool(id) {
            axios.delete('/api/admin/free-pools/' + id)
                .then(res => { 
                    this.showAlert(res.data.message);
                    this.loadFreePools(); 
                })
                .catch(err => this.showAlert(err.response.data.message, true)
            );
        },
        // --- KATEGORIE ---
        loadCategories() { 
            axios.get('/api/admin/categories')
                .then(res => this.categories = res.data); 
        },
        addCategory() {
            axios.post('/api/admin/categories', { name: this.newCatName })
                .then(res => { 
                    this.categories.push(res.data); 
                    this.newCatName = ''; 
                    this.showAlert("Dodano nową kategorię.");
            });
        },
        deleteCategory(id) {
            axios.delete('/api/admin/categories/' + id)
                .then(res => { 
                    this.showAlert(res.data.message);
                    this.loadCategories(); 
                })
                .catch(err => this.showAlert(err.response.data.message, true)
            );
        },
        // --- PAROWANIE (ŁĄCZENIE LIMITÓW) ---
        loadCategorySlotPools() { 
            axios.get('/api/admin/category-slot-pools')
                .then(res => this.categorySlotPools = res.data); 
        },
        assignPoolToCategoryAndSlot() {
            const payload = { category_id: this.assignCatId, slot_id: this.assignSlotId, free_pool_id: this.assignPoolId };
            axios.post('/api/admin/category-slot-pools', payload)
                .then(res => {
                    this.categorySlotPools.push(res.data);
                    this.assignCatId = '';
                    this.assignSlotId = '';
                    this.assignPoolId = '';
                    this.showAlert("Pomyślnie podpięto darmową pulę biletów do wybranego toru i godziny!");
                })
                .catch(err => this.showAlert(err.response.data.message || "Błąd parowania.", true)
            );
        },
        deleteAssignment(id) {
            axios.delete('/api/admin/category-slot-pools/' + id)
                .then(res => {
                    this.showAlert(res.data.message);
                    this.loadCategorySlotPools();
                }
            );
        },
        // Dopisz te metody na dole w methods:
        startEditSlot(slot) {
            this.editingSlotId = slot.id;
            this.editSlotValue = slot.total_capacity;
        },
        saveSlotCapacity(id) {
            axios.put('/api/admin/slots/' + id + '/capacity', { total_capacity: this.editSlotValue })
                .then(res => {
                    this.editingSlotId = null;
                    this.loadSlots(); // Odświeżamy listę godzin
                    this.showAlert("Pomyślnie zaktualizowano limit osób dla wybranej godziny.");
                })
                .catch(err => {
                    this.showAlert(err.response.data.message || "Błąd podczas aktualizacji limitu tury.", true);
                });
        },
        startEditSlotTime(slot) {
            this.editingSlotTimeId = slot.id;
            this.editSlotTimeValue = slot.time_string;
        },
        saveSlotTime(id) {
            axios.put('/api/admin/slots/' + id + '/time', { time_string: this.editSlotTimeValue })
                .then(res => {
                    this.editingSlotTimeId = null;
                    this.loadSlots(); // Odświeża listę godzin
                    this.showAlert("Format godziny został pomyślnie zaktualizowany.");
                })
                .catch(err => {
                    this.showAlert(err.response.data.message || "Niepoprawny format godziny.", true);
                });
        }                
    }
};      
</script>